<div class="coming-soon-container">
  <div class="coming-soon-content">
    <i class="fa fa-clock-o coming-soon-icon"></i>
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
  </div>
</div>
